export const DeliveryAddress = {
  HeaderTitle: '配送先住所',
  PrescribedAddress: '規定の住所',
  AddButton: '配送先を追加する',
  RegisterButton: '登録する',
  UpdateButton: '更新する',
  DeleteButton: '削除する',
  RegisterHeaderTitle: '配送先住所の登録',
  UpdateHeaderTitle: '配送先住所の更新',
  Dialog: {
    Text: '配送先住所を削除しますか？',
  },
  Form: {
    DestinationName: '宛先名',
    PostalCode: '郵便番号(ハイフンなし)',
    SearchAddressBtn: '住所検索',
    PrefectureCode: '都道府県',
    CityBlock: '市区町村・番地',
    BuildingName: '建物名・部屋番号',
    CompanyName: '法人名・会社名',
    DivisionName: '部署名',
    PhoneNumber: '電話番号(ハイフンなし) (※)',
    MobilePhoneNumber: '携帯番号(ハイフンなし) (※)',
    Annotation: '※電話番号、または携帯番号のいずれかを入力してください。',
    IsDefault: 'いつもこの住所に届ける(既定の住所)',
    Placeholder: {
      DestinationName: '名前',
      PostalCode: '123456',
      PrefectureCode: '選択してください',
      CityBlock: '例：〇〇市 〇〇町',
      BuildingName: '〇〇マンション 〇〇号室',
      PhoneNumber: '09012345678',
      MobilePhoneNumber: '09012345678',
    },
    PostalNotFound: '該当する住所が見つかりませんでした。',
  },
};
